import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { getCookieConsent, setCookieConsent } from '@/utils/cookieConsent';
import { Cookie, Info } from 'lucide-react';
import CookieSettingsDialog from './CookieSettingsDialog';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    const existingConsent = getCookieConsent();
    if (!existingConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent({
      necessary: true,
    });
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <>
      {/* Cookie Notice Banner */}
      <div className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-300">
        <div className="mx-auto max-w-7xl px-4 pb-4 sm:px-6 lg:px-8">
          <div className="glass-surface glass-strong rounded-lg p-4 sm:p-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div className="flex-1 space-y-2">
                <div className="flex items-center gap-2">
                  <Cookie className="h-5 w-5 text-muted-foreground" />
                  <h3 className="text-base font-semibold text-foreground">
                    {t('cookie_banner.title.translation')}
                  </h3>
                </div>
                <p className="text-sm text-muted-foreground">
                  {t('cookie_banner.description.translation')}
                </p>
                <button
                  onClick={() => setShowInfo(true)}
                  className="flex items-center gap-1 bg-transparent text-sm text-muted-foreground underline hover:text-foreground"
                >
                  <Info className="h-4 w-4" />
                  {t('cookie_banner.learn_more.translation')}
                </button>
              </div>
              <div className="flex items-center">
                <Button
                  variant="default"
                  size="sm"
                  onClick={handleAccept}
                  className="w-full sm:w-auto"
                >
                  {t('cookie_banner.accept.translation')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CookieSettingsDialog open={showInfo} onOpenChange={setShowInfo} />
    </>
  );
};

export default CookieBanner;
